const getMeetingEmails = (meeting) => {
    const possibleEmails = [
        meeting?.booking?.email,
        meeting?.booking?.inviteeEmail,
        meeting?.booking?.calendlyInvitee?.email,
        meeting?.booking?.calendlyEvent?.invitee?.email,
        meeting?.booking?.calendlyEvent?.invitees?.email,
        meeting?.booking?.calendlyEvent?.resource?.email,
        meeting?.order?.customer?.email,
        meeting?.order?.email,
    ];

    return possibleEmails
        .filter(Boolean)
        .map((email) => email.toLowerCase().trim());
};

const isNotFoundError = (error) => (
    error?.response?.status === 404
    || error?.status === 404
    || error?.error === 'NotFound'
);

export const findMeetingsByEmail = async ({
    organisationId,
    email,
    meetings,
    getUserByEmail,
    getAllMeetings,
}) => {
    const normalizedEmail = email?.trim().toLowerCase();
    if (!normalizedEmail) {
        return [];
    }

    let matchedUserId = '';
    try {
        const user = await getUserByEmail(organisationId, normalizedEmail);
        matchedUserId = user?.userId || '';
    } catch (error) {
        if (!isNotFoundError(error)) {
            throw error;
        }
    }

    const meetingsToSearch = meetings || await getAllMeetings(organisationId);

    return (meetingsToSearch || []).filter((meeting) => {
        if (matchedUserId && meeting?.order?.customer?.userId === matchedUserId) {
            return true;
        }

        return getMeetingEmails(meeting).includes(normalizedEmail);
    });
};
